<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-attachment`]" width="1em" height="1em" v-bind="$attrs"><path d="M27.171 14.358l-12.36 12.36a5.915 5.915 0 008.364 8.365l14.06-14.06c3.839-3.838 3.839-10.062 0-13.9-3.839-3.84-10.063-3.84-13.901 0L8.716 21.737c-5.272 5.272-5.272 13.82 0 19.092 5.273 5.272 13.82 5.272 19.092 0l10.615-10.615a2 2 0 00-2.828-2.828L24.98 38.002a9.5 9.5 0 01-13.435-13.435L26.162 9.95a5.83 5.83 0 118.245 8.244l-14.06 14.06a1.915 1.915 0 01-2.708-2.708l12.36-12.36a2 2 0 10-2.828-2.83z"/></svg>
</template>
<script>

export default {
  name: 'IconAttachment',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
